export default __webpack_public_path__ + "static/media/meta-chart.040e928f.jpg";